import { clsx } from "clsx";
import { twMerge } from "tailwind-merge";
export function cn() {
    for(var _len = arguments.length, inputs = new Array(_len), _key = 0; _key < _len; _key++){
        inputs[_key] = arguments[_key];
    }
    return twMerge(clsx(inputs));
}
export function getAbbreviation() {
    let text = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : '', limit = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 2;
    var _text_match;
    const textArray = (_text_match = text.match(/\b([A-Za-z0-9])/g)) !== null && _text_match !== void 0 ? _text_match : [];
    if (textArray.length >= limit) {
        return textArray.slice(0, limit).join('').toUpperCase();
    }
    return text.slice(0, 2).toUpperCase();
}
